import React from 'react';
import { Skeleton,Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch ,Tabs} from 'antd';
import SurveyVerification from './SurveyVerification';
import UserActivityLogInformation from './UserActivityLogInformation';
import UserActivityTransactionInformation from './UserActivityTransactionInformation';
const { TabPane } = Tabs;


export const AdministrationInterface = (props) => {
 

    return (
        <Tabs defaultActiveKey="1">

        <TabPane tab="Unesene ankete" key="1">
        <UserActivityTransactionInformation/>
        </TabPane>
          
          
        

        <TabPane tab="Loggovi" key="2">
        <UserActivityLogInformation/>
        </TabPane>

        <TabPane tab="Verifikacija anketa" key="3">
          <SurveyVerification/>
        </TabPane>




        </Tabs>
    )
}
export default AdministrationInterface;